'use strict'

import model from '@/model'

const get = async () => {
  log('deviceHandler.get()')
  const devices = await model.device.get()
  return _.orderBy(devices, 'order', 'asc')
}

export default {
  get
}
